/* RESPONSIBLE TEAM: team-automation-foundations */
import { hasMany } from '@ember-data/model';
import TicketTypeSummary from './ticket-type-summary';
import { getEmberDataStore } from '../../lib/container-lookup';
import { inject as service } from '@ember/service';
export default class TicketType extends TicketTypeSummary {
  @service store;
  @service session;

  @hasMany('conversation-attributes/descriptor', { async: false }) descriptors;

  async save(...args) {
    let result = await super.save(...args);
    this.afterSaveCallback();
    return result;
  }

  // any time we save the ticket type we want to make sure the ticket types in the inbox
  // will be reloaded
  afterSaveCallback() {
    this.session.workspace.resetTicketTypes();
  }

  get userVisibleDescriptors() {
    return this.descriptors.filter((x) => x.visibleToUsers && !x.archived);
  }

  static peekAllAndMaybeLoad() {
    let store = getEmberDataStore();
    let records = store.peekAll('inbox/ticket-type');

    if (!records.length) {
      records = store.findAll('inbox/ticket-type');
    }
    return records;
  }

  static ticketTypesByCategory(ticketTypes) {
    if (!ticketTypes) {
      return [];
    }

    return ticketTypes.reduce((groupedTickets, ticket) => {
      if (!groupedTickets[ticket.category]) {
        groupedTickets[ticket.category] = [];
      }

      groupedTickets[ticket.category].push(ticket);

      return groupedTickets;
    }, {});
  }
}
